import React, { useEffect, useState } from 'react'
import StructureQuestion from '../components/questions/StructureQuestion';
import ReadingQuestion from '../components/questions/ReadingQuestion';
import ListeningQuestion from '../components/questions/ListeningQuestion';
import Swal from 'sweetalert2'
import '../pages/style.css'
import { useLocation, useNavigate } from 'react-router-dom';
import WritingQuestion from '../components/questions/WritingQuestion';
import URL from '../service/API_URL'
import { useClipboardBlock } from './hooks/useClipboardBlock';
import { Typeahead } from 'react-bootstrap-typeahead';

export const PlacementTest = () => {
    const location = useLocation()
    const navigate = useNavigate()

    useClipboardBlock();

    const [structureQuestion, setStructureQuestion] = useState([]);
    const [structureComplete1, setStructureComplete1] = useState([]);
    const [structureWrong, setStructureWrong] = useState([]);
    const [structureComplete2, setStructureComplete2] = useState([]);
    // ------------------------------------------------------------//
    const [readingQuestion, setReadingQuestion] = useState([]);
    const [listeningQuestion, setListeningQuestion] = useState([]);
    const [arrangeQuestion, setArrangeQuestion] = useState([]);
    const [writingQuestion, setWritingQuestion] = useState([]);
    // ------------------------------------------------------------//
    const [structureAnswer, setStructureAnswer] = useState([]);
    const [readingAnswer, setReadingAnswer] = useState([]);
    const [listeningAnswer, setListeningAnswer] = useState([]);
    const [arrangeAnswer, setArrangeAnswer] = useState([]);
    const [writingAnswer, setWritingAnswer] = useState([]);
    // ------------------------------------------------------------//
    const [showStructure, setShowStructure] = useState(true);
    const [showReading, setShowReading] = useState(false);
    const [showListening, setShowListening] = useState(false);
    const [showWriting, setShowWriting] = useState(false);
    // ------------------------------------------------------------//
    const [loading, setLoading] = useState(false)
    // ------------------------------------------------------------//
    // console.log(location);
    const user = location?.state;
    const id_user = location?.state?.id;
    const [showCompletionForm, setShowCompletionForm] = useState(false);
    const [provinces, setProvinces] = useState([]);
    const [educationLevels, setEducationLevels] = useState([]);
    const [schools, setSchools] = useState([]);
    const [provinceId, setProvinceId] = useState('');
    const [educationCode, setEducationCode] = useState('');
    const [selectedSchool, setSelectedSchool] = useState([]);
    const [profileError, setProfileError] = useState({});
    const [submitError, setSubmitError] = useState('');
    // ------------------------------------------------------------//
    const [isMobile, setIsMobile] = useState(false)

    //choose the screen size 
    const handleResize = () => {
        if (window.innerWidth < 769) {
            setIsMobile(true)
        } else {
            setIsMobile(false)
        }
    }
    useEffect(() => {
        handleResize()
        window.addEventListener("resize", handleResize)
        return () => window.removeEventListener("resize", handleResize)
    }, [])

    useEffect(() => {
        if (!user) {
            navigate('/');
        }
    }, [user, navigate])

    useEffect(() => {
        if (!showCompletionForm) return;

        Promise.all([
            URL.urlApplication.get('master/provinces'),
            URL.urlApplication.get('master/jenjang')
        ])
            .then(([provinceResponse, educationResponse]) => {
                setProvinces(provinceResponse.data.data || []);
                setEducationLevels(educationResponse.data.data || []);
            })
            .catch(() => setSubmitError('Data sekolah belum dapat dimuat. Coba tutup lalu buka kembali form ini.'));
    }, [showCompletionForm])

    useEffect(() => {
        if (!provinceId || !educationCode) {
            setSchools([]);
            setSelectedSchool([]);
            return;
        }

        URL.urlApplication.get(`sekolah-indonesia?province_id=${provinceId}&jenjang=${educationCode}`)
            .then((response) => setSchools(response.data.data || []))
            .catch(() => setSubmitError('Daftar sekolah belum dapat dimuat. Silakan coba lagi.'));
    }, [provinceId, educationCode])

    const handleShowStructure = () => {
        setShowStructure(true)
        setShowReading(false)
        setShowListening(false)
        setShowWriting(false)
    }
    const handleShowReading = () => {
        setShowStructure(false)
        setShowReading(true)
        setShowListening(false)
        setShowWriting(false)
    }
    const handleShowListening = () => {
        setShowStructure(false)
        setShowReading(false)
        setShowListening(true)
        setShowWriting(false)
    }
    const handleShowWriting = () => {
        setShowStructure(false)
        setShowReading(false)
        setShowListening(false)
        setShowWriting(true)
    }

    const handleStructureAnswers = (e, correct_answer, i) => {
        let _answer = [...structureAnswer]
        _answer[i].option = e.target.value
        _answer[i].correct_answer = correct_answer
        _answer.push()
    }

    const handleReadingAnswers = (e, correct_answer, k) => {
        let _answer = [...readingAnswer]
        _answer[k].option = e.target.value
        _answer[k].correct_answer = correct_answer
        _answer.push()
    }

    const handleListeningAnswers = (e, correct_answer, k) => {
        let _answer = [...listeningAnswer]
        _answer[k].option = e.target.value
        _answer[k].correct_answer = correct_answer
        _answer.push()
    }

    const handleWritingAnswer = (e) => {
        let _answer = { ...writingAnswer, index: 1, option: e, correct_answer: 'null' }
        setWritingAnswer(_answer);
    }

    const handleClick = () => {
        setSubmitError('');
        setShowCompletionForm(true);
    }

    const submitTest = async (event) => {
        event.preventDefault();
        const errors = {};
        if (!provinceId) errors.province = 'Pilih provinsi sekolah.';
        if (!educationCode) errors.education = 'Pilih jenjang pendidikan.';
        if (!selectedSchool.length) errors.school = 'Pilih sekolah kamu.';
        setProfileError(errors);
        if (Object.keys(errors).length > 0) return;

        setLoading(true)
        setSubmitError('')
        let final_answer = [];
        let score = [];

        let point1 = 0;
        for (let i = 0; i < structureQuestion.length; i++) {
            if (structureAnswer[i]?.option === structureQuestion[i]?.correct_answer) {
                point1++
            }
        }
        let point2 = 0;
        for (let i = 0; i < readingAnswer.length; i++) {
            if (readingAnswer[i].correct_answer === readingAnswer[i].option) {
                point2++
            }
        }
        let point4 = 0
        // for (let i = 0; i < arrangeQuestion.length; i++) {
        //     if (arrangeAnswer[i].text_arrange === arrangeQuestion[i].text_arrange) {
        //         point4++
        //     }
        // }
        try {
            const registerResponse = await URL.API_URL.post('register', {
                ...user,
                kode_sekolah: selectedSchool[0].kode_sekolah
            });
            const registeredUserId = registerResponse.data.data.id;

            score.push({
                structureScore: point1,
                readingScore: point2 + point4,
                id_user: registeredUserId,
                countStructure: structureAnswer.length,
                countReading: readingAnswer.length,
            })

            final_answer = [...structureAnswer, ...readingAnswer].map((answer) => ({
                option: answer.option,
                correct_answer: answer.correct_answer,
                id_user: registeredUserId,
                id_question: answer.id_question
            }));

            await URL.API_URL.post('storeAnswers', final_answer);
            await URL.API_URL.post('storeScore', score);

            setShowCompletionForm(false);
            await Swal.fire({
                icon: 'success',
                title: 'Test submitted!',
                text: 'Your result has been processed. Check your WhatsApp for the next step.',
                confirmButtonText: 'Back to home',
                confirmButtonColor: '#CB2525'
            });
            navigate('/');
        } catch (error) {
            setSubmitError('Test kamu belum berhasil dikirim. Jawaban tetap ada di halaman ini—silakan coba lagi.');
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        getStructureQuestion();
        getReadingQuestion();
        // getListeningQuestion();
        // getArrangeQuestion();
    }, [])

    const getStructureQuestion = () => {
        URL.API_URL.get('question')
            .then(res => {
                const data = res.data.data
                const completeSentenceQuestion1 = []
                const wrongSentenceQuestion = []
                const completeSentenceQuestion2 = []
                const writingQuestion = [];
                let tempStructure = [];
                let tempWriting = [];

                for (let j = 0; j < data.length; j++) {
                    const answers = [data[j].opt_a, data[j].opt_b, data[j].opt_c, data[j].opt_d]
                    const newAnswers = answers.slice()
                    for (let i = newAnswers.length - 1; i > 0; i--) {
                        const rand = Math.floor(Math.random() * (i + 1));
                        [newAnswers[i], newAnswers[rand]] = [newAnswers[rand], newAnswers[i]];
                    }
                    if (data[j].id_question_type === 1) {
                        tempStructure.push({ 'index': j + 1, 'option': 'No Answer', 'correct_answer': data[j].opt_a, 'id_user': id_user, 'id_question': data[j].id });
                        if (data[j].id_structure_type === 1) {
                            completeSentenceQuestion1.push({
                                id: data[j].id,
                                question: data[j].question,
                                answers: newAnswers,
                                question_type: data[j].tb_question_type?.question_type,
                                correct_answer: data[j].opt_a
                            })
                        } else if (data[j].id_structure_type === 2) {
                            wrongSentenceQuestion.push({
                                id: data[j].id,
                                question: data[j].question,
                                answers: newAnswers,
                                question_type: data[j].tb_question_type?.question_type,
                                correct_answer: data[j].opt_a
                            })
                        } else if (data[j].id_structure_type === 3) {
                            completeSentenceQuestion2.push({
                                id: data[j].id,
                                question: data[j].question,
                                answers: newAnswers,
                                question_type: data[j].tb_question_type?.question_type,
                                correct_answer: data[j].opt_a
                            })
                        }
                    }

                    if (data[j].id_question_type === 4) {
                        tempWriting.push({
                            index: j + 1,
                            option: 'No Answer',
                            correct_answer: 'null',
                            id_user: id_user, id_question: data[j].id
                        })
                        writingQuestion.push({
                            id: data[j].id,
                            question: data[j].question,
                            question_type: data[j].id_question_type,
                        })
                    }
                }
                const rand = Math.floor(Math.random() * writingQuestion.length)
                setStructureAnswer(tempStructure);
                setStructureQuestion(tempStructure);
                setStructureComplete1(completeSentenceQuestion1);
                setStructureWrong(wrongSentenceQuestion);
                setStructureComplete2(completeSentenceQuestion2);
                setWritingAnswer(tempWriting[rand])
                setWritingQuestion(writingQuestion[rand].question);
            })
            .catch(err => console.log(err))
    }

    const getReadingQuestion = () => {
        URL.API_URL.get('readingQuestion')
            .then(res => {
                const data = res.data.data;
                let tempReading = []
                let o = 1
                for (let j = 0; j < data.length; j++) {
                    const question = data[j].tb_question;
                    for (let i = 0; i < question.length; i++) {
                        tempReading.push({ 'index': o++, 'option': 'No Answer', 'correct_answer': data[j].tb_question[i].opt_a, 'id_user': id_user, 'id_question': data[j].tb_question[i].id });
                        const answer = [data[j].tb_question[i].opt_a, data[j].tb_question[i].opt_b, data[j].tb_question[i].opt_c, data[j].tb_question[i].opt_d]
                        const newAnswer = answer.slice()
                        for (let k = newAnswer.length - 1; k > 0; k--) {
                            const rand = Math.floor(Math.random() * (k + 1));
                            [newAnswer[k], newAnswer[rand]] = [newAnswer[rand], newAnswer[k]];
                        }
                        data[j].tb_question[i].answer = newAnswer;
                        data[j].tb_question[i].correct_answer = data[j].tb_question[i].opt_a;
                    };
                }
                setReadingAnswer(tempReading)
                setReadingQuestion(data);
            })
            .catch(err => console.log(err))
    }

    const getListeningQuestion = () => {
        URL.API_URL.get('listeningQuestion')
            .then(res => {
                const data = res.data.data;
                let tempListening = []
                let o = 1;
                for (let j = 0; j < data.length; j++) {
                    const question = data[j].tb_question;
                    for (let i = 0; i < question.length; i++) {
                        tempListening.push({ 'index': o++, 'option': 'No Answer', 'correct_answer': data[j].tb_question[i].opt_a, 'id_user': id_user, 'id_question': data[j].tb_question[i].id });
                        const answer = [data[j].tb_question[i].opt_a, data[j].tb_question[i].opt_b, data[j].tb_question[i].opt_c, data[j].tb_question[i].opt_d]
                        const newAnswer = answer.slice()
                        for (let k = newAnswer.length - 1; k > 0; k--) {
                            const rand = Math.floor(Math.random() * (k + 1));
                            [newAnswer[k], newAnswer[rand]] = [newAnswer[rand], newAnswer[k]];
                        }
                        data[j].tb_question[i].answer = newAnswer;
                        data[j].tb_question[i].correct_answer = data[j].tb_question[i].opt_a;
                    };
                }
                setListeningAnswer(tempListening)
                setListeningQuestion(data);
            })
    }

    const getArrangeQuestion = () => {
        URL.API_URL.get('arrangeQuestion')
            .then(res => {
                const data = res.data.data
                const newData = data.slice()

                for (let i = data.length - 1; i > 0; i--) {
                    const rand = Math.floor(Math.random() * (i + 1));
                    [newData[i], newData[rand]] = [newData[rand], newData[i]];
                }
                setArrangeQuestion(newData);
                setArrangeAnswer(data);
            })
    }

    return (
        <div className="test-page">
            <div className="container">
                <div className="header">
                    <p>NIEC English Course</p>
                    <h1>Placement Test</h1>
                </div>
                {showStructure && (
                    <StructureQuestion
                        structureQuestion1={structureComplete1}
                        structureQuestion2={structureWrong}
                        structureQuestion3={structureComplete2}
                        structureAnswer={structureAnswer}
                        handleStructureAnswers={handleStructureAnswers}
                    />
                )
                }
                {showReading && (
                    <ReadingQuestion
                        handleReadingAnswers={handleReadingAnswers}
                        readingQuestion={readingQuestion}
                        arrangeQuestion={arrangeQuestion}
                        arrangeAnswer={arrangeAnswer}
                        setArrangeQuestion={setArrangeQuestion}
                        readingAnswer={readingAnswer} />
                )
                }
                {showListening && (
                    <ListeningQuestion
                        handleListeningAnswers={handleListeningAnswers}
                        listeningQuestion={listeningQuestion}
                        // submitListening={submitListening}
                        listeningAnswer={listeningAnswer}
                        isMobile={isMobile} />
                )
                }
                {showWriting && (
                    <WritingQuestion
                        writingQuestion={writingQuestion}
                        handleWritingAnswer={handleWritingAnswer}
                        writingAnswer={writingAnswer}
                    />
                )
                }
                {/* {isMobile && (
            <div className="btn-wrapp">
                <button disabled={loading ? true : false} className={`btn btn-submit-test reverse`} onClick={handleClick}>Submit Test</button>
            </div>
        )}   */}
            </div>
            {/* {!isMobile && ( */}
            <div className="btn-wrapper">
                <div className="row h-100">
                    <div className="col-lg-8 btn-navigation">
                        <button onClick={handleShowStructure} className={`btn btn-nav-test ${showStructure && 'showing'}`}>Structure</button>
                        <button onClick={handleShowReading} className={`btn btn-nav-test ${showReading && 'showing'}`}>Reading</button>
                        {/* <button onClick={handleShowListening} className={`btn btn-nav-test ${showListening && 'showing'}`}>Listening</button>
                    <button onClick={handleShowWriting} className={`btn btn-nav-test ${showWriting && 'showing'}`}>Writing</button> */}
                    </div>
                    <div className="col-lg-4 btn-submit">
                        <button disabled={loading ? true : false} className='btn btn-submit-test' onClick={handleClick}>Submit Test</button>
                    </div>
                </div>
            </div>
            {/* )} */}

            {showCompletionForm && (
                <div className="profile-modal-backdrop" role="dialog" aria-modal="true" aria-labelledby="profile-title">
                    <form className="profile-modal" onSubmit={submitTest}>
                        <div className="profile-modal-head">
                            <div>
                                <span className="section-kicker">One last step</span>
                                <h2 id="profile-title">Complete your profile</h2>
                                <p>Tell us about your school so we can prepare the right result for you.</p>
                            </div>
                            <button className="modal-close" type="button" aria-label="Close profile form" onClick={() => setShowCompletionForm(false)}>×</button>
                        </div>

                        <div className="profile-fields">
                            <div className="field-group">
                                <label htmlFor="province">School province</label>
                                <select id="province" value={provinceId} className={profileError.province ? 'has-error' : ''} onChange={(event) => { setProvinceId(event.target.value); setProfileError((current) => ({ ...current, province: '' })) }}>
                                    <option value="">Choose province</option>
                                    {provinces.map((province) => <option key={province.id} value={province.id}>{province.province_name}</option>)}
                                </select>
                                {profileError.province && <small className="field-error">{profileError.province}</small>}
                            </div>

                            <div className="field-group">
                                <label htmlFor="education-level">Education level</label>
                                <select id="education-level" value={educationCode} className={profileError.education ? 'has-error' : ''} onChange={(event) => { setEducationCode(event.target.value); setProfileError((current) => ({ ...current, education: '' })) }}>
                                    <option value="">Choose level</option>
                                    {educationLevels.map((level) => <option key={level.code_jenjang} value={level.code_jenjang}>{level.jenjang_pendidikan}</option>)}
                                </select>
                                {profileError.education && <small className="field-error">{profileError.education}</small>}
                            </div>

                            <div className="field-group school-field">
                                <label htmlFor="school">School name</label>
                                <Typeahead
                                    id="school"
                                    labelKey="nama_sekolah"
                                    options={schools}
                                    selected={selectedSchool}
                                    onChange={(selection) => { setSelectedSchool(selection); setProfileError((current) => ({ ...current, school: '' })) }}
                                    placeholder={provinceId && educationCode ? 'Search your school' : 'Choose province and level first'}
                                    disabled={!provinceId || !educationCode}
                                    inputProps={{ className: profileError.school ? 'has-error' : '' }}
                                />
                                {profileError.school && <small className="field-error">{profileError.school}</small>}
                            </div>
                        </div>

                        {submitError && <p className="submit-error" role="alert">{submitError}</p>}

                        <div className="profile-actions">
                            <button className="profile-back" type="button" onClick={() => setShowCompletionForm(false)}>Review answers</button>
                            <button className="profile-finish" type="submit" disabled={loading}>{loading ? 'Submitting...' : 'Get my result'}</button>
                        </div>
                    </form>
                </div>
            )}
        </div>
    )
}
